/**
 * HOLE Foundation Auth0 Provider - SIMPLIFIED
 *
 * Basic Auth0 integration without organization complexity
 * Phase 1: Database authentication (username/password)
 * Phase 2: Add OAuth/SSO later
 */

import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { ReactNode } from 'react';
import { getAuth0Config, AUTH0_SCOPES } from './config';

interface HoleAuth0ProviderProps {
  children: ReactNode;
}

/**
 * Handle redirect callback after login
 * Uses window.location instead of useNavigate to avoid React Router context issues
 */
const onRedirectCallback = (appState?: AppState) => {
  window.location.href = appState?.returnTo || window.location.pathname;
};

/**
 * Auth0Provider wrapper that works with React Router
 * Must be nested inside BrowserRouter
 */
export function HoleAuth0ProviderWithRouter({ children }: HoleAuth0ProviderProps) {
  const config = getAuth0Config();

  return (
    <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      authorizationParams={{
        redirect_uri: config.redirectUri,
        audience: config.audience,
        scope: AUTH0_SCOPES.full
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}
